import {Dispatch, SetStateAction, useCallback, useMemo} from 'react';
import {useHistory, useParams} from 'react-router';
import {BECompetitionDetail} from 'API/types';
import {SearchTerm, Sport} from 'utils/types';
import {competitionsToSearchTerms} from 'utils/sportsUtils';

/**
 * Stores the filter value entered in the search term. Uses router params to handle filter deeplinks.
 */

const useSearchTerm = (
  competitions?: BECompetitionDetail[]
): [SearchTerm | undefined, string | undefined, Dispatch<SetStateAction<SearchTerm>>] => {
  // TODO: handle autocompletion here?
  // TODO; better props type declaration

  const history = useHistory();
  const {filter} = useParams<{filter: string}>();

  const [searchTerm, grName]: [SearchTerm | undefined, string | undefined] = useMemo(() => {
    // BIQ: fetch competitions - wait for competitions to fetch before deciding we have a valid filter

    if (filter) {
      const slug = filter.match(/([a-zA-Z0-9-]+)-live/);
      const items = competitionsToSearchTerms(competitions);

      if (slug && slug[1]) {
        const result = items.find(i => i.slug === slug[1]);
        if (result) return [result.id, result.name];
      }
    }

    return [undefined, undefined];
  }, [filter, competitions]);

  const setSearchTerm = useCallback(
    term => {
      if (term) {
        const items = competitionsToSearchTerms(competitions);
        const slug = items.find(i => i.id === term)?.slug;

        if (slug) history.push(`/${slug}-live`);
      } else {
        history.push('/');
      }
    },
    [history, competitions]
  );

  return [searchTerm, grName, setSearchTerm];
};

export default useSearchTerm;
